import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-562ebb4d")

_pushScopeId("data-v-562ebb4d")
const _hoisted_1 = { class: "message" }
const _hoisted_2 = { class: "message-wrap" }
const _hoisted_3 = { class: "name-wrap" }
const _hoisted_4 = { class: "name-status" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ButtonStatus = _resolveComponent("ButtonStatus")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      class: "avatar",
      src: _ctx.avatar,
      alt: _ctx.name
    }, null, 8, ["src", "alt"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("p", _hoisted_5, _toDisplayString(_ctx.name), 1),
          (_ctx.isPrivate)
            ? (_openBlock(), _createBlock(_component_ButtonStatus, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _createVNode("p", _hoisted_6, _toDisplayString(_ctx.time), 1)
      ]),
      _createVNode("p", _hoisted_7, _toDisplayString(_ctx.message), 1)
    ])
  ]))
})